import { render, staticRenderFns } from "./DiagnosticFormDoctor.vue?vue&type=template&id=1dc8c682&scoped=true"
import script from "./DiagnosticFormDoctor.vue?vue&type=script&lang=js"
export * from "./DiagnosticFormDoctor.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticFormDoctor.vue?vue&type=style&index=0&id=1dc8c682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8c682",
  null
  
)

export default component.exports